import React, {Component} from 'react';
import {connect} from 'react-redux';
import {Link, NavLink} from 'react-router-dom';
import {
    // UncontrolledTooltip,
    Collapse,
    Nav,
    Navbar,
    NavItem,
    NavLink as BSNavLink,
} from 'reactstrap';
import {MdDashboard, MdKeyboardArrowDown, MdEmail} from 'react-icons/md';
import {
    FaUserAlt,
    // FaProductHunt,
    // FaShoppingCart,
    FaTachometerAlt,
    FaDonate,
    FaUserTie,
    FaBell
} from "react-icons/fa";
import {RiCheckboxBlankCircleLine} from "react-icons/ri";
import {AiFillSetting} from "react-icons/ai";
import navItem from '../../configs/AdminNav';

import sidebarBgImage from '../../assets/img/sidebar/sidebar-4.jpg';
import bn from '../../utils/bemnames';

const bem = bn.create('sidebar');
const sidebarBackground = {
    backgroundImage: `url("${sidebarBgImage}")`,
    backgroundSize: 'cover',
    backgroundRepeat: 'no-repeat',
};

class Sidebar extends Component {
    constructor(props) {
        super(props);
        this.state = {
            isOpenUser: false,
            isOpenProduct: false,
            isOpenOrder: false,
            isOpenPages: false,
            isOpenLog: false,
            isOpenConfigSystem: false,
            isOpenService: false,
            isOpenPayment: false,
            isOpenAgency: false,
            isOpenEmail: false,
            isOpenInfomation: false,
            isOpenSystem: false,
        }
    }

    handleClick = name => () => {
        this.setState(prevState => {
            const isOpen = prevState[`isOpen${name}`];
            return {
                [`isOpen${name}`]: !isOpen,
            };
        });
    };

    loadServiceMenu = () => {
        return (
            <>
                <NavItem
                    className={bem.e('nav-item')}
                    onClick={this.handleClick('Service')}
                >
                    <BSNavLink className={bem.e('nav-item-collapse')}>
                        <div className="d-flex">
                            <FaTachometerAlt className={bem.e('nav-item-icon')}/>
                            <span className="nav-title align-self-start">Quản lý dịch vụ</span>
                        </div>
                        <MdKeyboardArrowDown
                            className={bem.e('nav-item-icon')}
                            style={{
                                padding: 0,
                                transform: this.state.isOpenService
                                    ? 'rotate(0deg)'
                                    : 'rotate(-90deg)',
                                transitionDuration: '0.3s',
                                transitionProperty: 'transform',
                            }}
                        />
                    </BSNavLink>
                </NavItem>
                <Collapse isOpen={this.state.isOpenService} className="collapse-group">
                    {
                        this.props.vps ? (
                            <NavItem className={bem.e('nav-item')}>
                                <BSNavLink
                                    id={"service_vps"}
                                    className=""
                                    tag={NavLink}
                                    to={"/admin/vps/danh-sach-vps.html"}
                                    activeclassname=""
                                    exact={"false"}
                                >
                                    <RiCheckboxBlankCircleLine className={bem.e('nav-item-icon')}/>
                                    <span className="">Cloud VPS VN</span>
                                </BSNavLink>
                            </NavItem>
                        ) : (
                            <></>
                        )
                    }
                    {
                        this.props.vps_us ? (
                            <NavItem className={bem.e('nav-item')}>
                                <BSNavLink
                                    id={"service_vps_us"}
                                    className=""
                                    tag={NavLink}
                                    to={"/admin/vps-us/danh-sach.html"}
                                    activeclassname=""
                                    exact={"false"}
                                >
                                    <RiCheckboxBlankCircleLine className={bem.e('nav-item-icon')}/>
                                    <span className="">Dịch vụ VPS NN</span>
                                </BSNavLink>
                            </NavItem>
                        ) : (
                            <></>
                        )
                    }
                    {
                        this.props.cloudServer ? (
                            <NavItem className={bem.e('nav-item')}>
                                <BSNavLink
                                    id={"service_cloud_server"}
                                    className=""
                                    tag={NavLink}
                                    to={"/admin/vps/danh-sach-vps.html"}
                                    activeclassname=""
                                    exact={"false"}
                                >
                                    <RiCheckboxBlankCircleLine className={bem.e('nav-item-icon')}/>
                                    <span className="">Cloud Server</span>
                                </BSNavLink>
                            </NavItem>
                        ) : (
                            <></>
                        )
                    }
                    {
                        this.props.proxy ? (
                            <NavItem className={bem.e('nav-item')}>
                                <BSNavLink
                                    id={"service_proxy"}
                                    className=""
                                    tag={NavLink}
                                    to={"/admin/proxy/danh-sach.html"}
                                    activeclassname=""
                                    exact={"false"}
                                >
                                    <RiCheckboxBlankCircleLine className={bem.e('nav-item-icon')}/>
                                    <span className="">Proxy</span>
                                </BSNavLink>
                            </NavItem>
                        ) : (
                            <></>
                        )
                    }
                    {
                        this.props.hosting ? (
                            <NavItem className={bem.e('nav-item')}>
                                <BSNavLink
                                    id={"service_hosting"}
                                    className=""
                                    tag={NavLink}
                                    to={"/admin/hosting/danh-sach-hosting.html"}
                                    activeclassname=""
                                    exact={"false"}
                                >
                                    <RiCheckboxBlankCircleLine className={bem.e('nav-item-icon')}/>
                                    <span className="">Cloud Hosting</span>
                                </BSNavLink>
                            </NavItem>
                        ) : (
                            <></>
                        )
                    }
                </Collapse>
            </>
        );
    }

    render() {
        return (
            <aside
                // className="cr-sidebar cr-sidebar--open"
                className={bem.b()} data-image={sidebarBgImage}
            >
                <div
                    // className="cr-sidebar__background"
                    className={bem.e('background')} style={sidebarBackground}
                />
                <div
                    // className="cr-sidebar__content"
                    className={bem.e('content')}
                >
                    <Navbar>
                        <Link to="/admin" className="brand-link">
                            <img src={this.props.config.website_logo_w}
                                 width="35"
                                 height="35"
                                 className="brand-image img-circle"
                                 alt="logo"
                            />
                            <span className="text-white brand-text font-weight-light">
                        {this.props.config.website_company}
                    </span>
                        </Link>
                    </Navbar>
                    <Nav vertical>
                        {/* DashBoard */}
                        {
                            navItem.dashboar.map(({to, name, exact, Icon}, index) => (
                                <NavItem key={index} className={bem.e('nav-item')}>
                                    <BSNavLink
                                        id={`navItem-${name}-${index}`}
                                        tag={NavLink}
                                        to={to}
                                        exact={exact}
                                    >
                                        <MdDashboard className={bem.e('nav-item-icon')}/>
                                        <span className="nav-title">DashBoard</span>
                                    </BSNavLink>
                                </NavItem>
                            ))
                        }
                        {/* Agency */}
                        <NavItem
                            className={bem.e('nav-item')}
                            onClick={this.handleClick('Agency')}
                        >
                            <BSNavLink className={bem.e('nav-item-collapse')}>
                                <div className="d-flex">
                                    <FaUserTie className={bem.e('nav-item-icon')}/>
                                    <span className="nav-title align-self-start">Đại lý</span>
                                </div>
                                <MdKeyboardArrowDown
                                    className={bem.e('nav-item-icon')}
                                    style={{
                                        padding: 0,
                                        transform: this.state.isOpenAgency
                                            ? 'rotate(0deg)'
                                            : 'rotate(-90deg)',
                                        transitionDuration: '0.3s',
                                        transitionProperty: 'transform',
                                    }}
                                />
                            </BSNavLink>
                        </NavItem>
                        <Collapse isOpen={this.state.isOpenAgency} className="collapse-group">
                            {
                                navItem.agency.map(({to, name, title, exact, Icon}, index) => (
                                    <NavItem key={index} className={bem.e('nav-item')}>
                                        <BSNavLink
                                            id={name}
                                            className=""
                                            tag={NavLink}
                                            to={to}
                                            activeclassname=""
                                            exact={exact}
                                        >
                                            <Icon className={bem.e('nav-item-icon')}/>
                                            <span className="">{title}</span>
                                        </BSNavLink>
                                    </NavItem>
                                ))
                            }
                        </Collapse>
                        {/* ./Agency */}
                        {/* User */}
                        <NavItem
                            className={bem.e('nav-item')}
                            onClick={this.handleClick('User')}
                        >
                            <BSNavLink className={bem.e('nav-item-collapse')}>
                                <div className="d-flex">
                                    <FaUserAlt className={bem.e('nav-item-icon')}/>
                                    <span className="nav-title align-self-start">Quản lý khách hàng</span>
                                </div>
                                <MdKeyboardArrowDown
                                    className={bem.e('nav-item-icon')}
                                    style={{
                                        padding: 0,
                                        transform: this.state.isOpenUser
                                            ? 'rotate(0deg)'
                                            : 'rotate(-90deg)',
                                        transitionDuration: '0.3s',
                                        transitionProperty: 'transform',
                                    }}
                                />
                            </BSNavLink>
                        </NavItem>
                        <Collapse isOpen={this.state.isOpenUser} className="collapse-group">
                            {
                                navItem.user.map(({to, name, title, exact, Icon}, index) => (
                                    <NavItem key={index} className={bem.e('nav-item')}>
                                        <BSNavLink
                                            id={name}
                                            className=""
                                            tag={NavLink}
                                            to={to}
                                            activeclassname=""
                                            exact={exact}
                                        >
                                            <Icon className={bem.e('nav-item-icon')}/>
                                            <span className="">{title}</span>
                                        </BSNavLink>
                                    </NavItem>
                                ))
                            }
                        </Collapse>
                        {/* ./User */}
                        {/* Product */}
                        {
                            navItem.product.map(({ to, name, title, exact, Icon }, index) => (
                                <NavItem key={index} className={bem.e('nav-item')}>
                                    <BSNavLink
                                        id={`navItem-${name}-${index}`}
                                        tag={NavLink}
                                        to={to}
                                        exact={exact}
                                    >
                                        <Icon className={bem.e('nav-item-icon')} />
                                        <span className="nav-title">{ title }</span>
                                    </BSNavLink>
                                </NavItem>
                            ))
                        }
                        {/* <NavItem
                            className={bem.e('nav-item')}
                            onClick={this.handleClick('Product')}
                        >
                            <BSNavLink className={bem.e('nav-item-collapse')}>
                                <div className="d-flex">
                                    <FaProductHunt className={bem.e('nav-item-icon')}/>
                                    <span className="nav-title align-self-start">Quản lý sản phẩm</span>
                                </div>
                                <MdKeyboardArrowDown
                                    className={bem.e('nav-item-icon')}
                                    style={{
                                        padding: 0,
                                        transform: this.state.isOpenProduct
                                            ? 'rotate(0deg)'
                                            : 'rotate(-90deg)',
                                        transitionDuration: '0.3s',
                                        transitionProperty: 'transform',
                                    }}
                                />
                            </BSNavLink>
                        </NavItem>
                        <Collapse isOpen={this.state.isOpenProduct} className="collapse-group">
                            {
                                navItem.product.map(({to, name, title, exact, Icon}, index) => (
                                    <NavItem key={index} className={bem.e('nav-item')}>
                                        <BSNavLink
                                            id={name}
                                            className=""
                                            tag={NavLink}
                                            to={to}
                                            activeclassname=""
                                            exact={exact}
                                        >
                                            <Icon className={bem.e('nav-item-icon')}/>
                                            <span className="">{title}</span>
                                        </BSNavLink>
                                    </NavItem>
                                ))
                            }
                        </Collapse> */}
                        {/* ./Product */}
                        {/* Order */}
                        {
                            navItem.order.map(({ to, name, title, exact, Icon }, index) => (
                                <NavItem key={index} className={bem.e('nav-item')}>
                                    <BSNavLink
                                        id={`navItem-${name}-${index}`}
                                        tag={NavLink}
                                        to={to}
                                        exact={exact}
                                    >
                                        <Icon className={bem.e('nav-item-icon')} />
                                        <span className="nav-title">{ title }</span>
                                    </BSNavLink>
                                </NavItem>
                            ))
                        }
                        {/* <NavItem
                            className={bem.e('nav-item')}
                            onClick={this.handleClick('Order')}
                        >
                            <BSNavLink className={bem.e('nav-item-collapse')}>
                                <div className="d-flex">
                                    <FaShoppingCart className={bem.e('nav-item-icon')}/>
                                    <span className="nav-title align-self-start">Quản lý đơn hàng</span>
                                </div>
                                <MdKeyboardArrowDown
                                    className={bem.e('nav-item-icon')}
                                    style={{
                                        padding: 0,
                                        transform: this.state.isOpenOrder
                                            ? 'rotate(0deg)'
                                            : 'rotate(-90deg)',
                                        transitionDuration: '0.3s',
                                        transitionProperty: 'transform',
                                    }}
                                />
                            </BSNavLink>
                        </NavItem>
                        <Collapse isOpen={this.state.isOpenOrder} className="collapse-group">
                            {
                                navItem.order.map(({to, name, title, exact, Icon}, index) => (
                                    <NavItem key={index} className={bem.e('nav-item')}>
                                        <BSNavLink
                                            id={name}
                                            className=""
                                            tag={NavLink}
                                            to={to}
                                            activeclassname=""
                                            exact={exact}
                                        >
                                            <Icon className={bem.e('nav-item-icon')}/>
                                            <span className="">{title}</span>
                                        </BSNavLink>
                                    </NavItem>
                                ))
                            }
                        </Collapse> */}
                        {/* ./Order */}
                        {/* Payment */}
                        <NavItem
                            className={bem.e('nav-item')}
                            onClick={this.handleClick('Payment')}
                        >
                            <BSNavLink className={bem.e('nav-item-collapse')}>
                                <div className="d-flex">
                                    <FaDonate className={bem.e('nav-item-icon')}/>
                                    <span className="nav-title align-self-start">Quản lý giao dịch</span>
                                </div>
                                <MdKeyboardArrowDown
                                    className={bem.e('nav-item-icon')}
                                    style={{
                                        padding: 0,
                                        transform: this.state.isOpenPayment
                                            ? 'rotate(0deg)'
                                            : 'rotate(-90deg)',
                                        transitionDuration: '0.3s',
                                        transitionProperty: 'transform',
                                    }}
                                />
                            </BSNavLink>
                        </NavItem>
                        <Collapse isOpen={this.state.isOpenPayment} className="collapse-group">
                            {
                                navItem.payment.map(({to, name, title, exact, Icon}, index) => (
                                    <NavItem key={index} className={bem.e('nav-item')}>
                                        <BSNavLink
                                            id={name}
                                            className=""
                                            tag={NavLink}
                                            to={to}
                                            activeclassname=""
                                            exact={exact}
                                        >
                                            <Icon className={bem.e('nav-item-icon')}/>
                                            <span className="">{title}</span>
                                        </BSNavLink>
                                    </NavItem>
                                ))
                            }
                        </Collapse>
                        {/* ./Payment */}
                        {/* Service */}
                        {
                            this.loadServiceMenu()
                        }
                        {/* ./Service */}

                        {/* Email */}
                        <NavItem
                            className={bem.e('nav-item')}
                            onClick={this.handleClick('Email')}
                        >
                            <BSNavLink className={bem.e('nav-item-collapse')}>
                                <div className="d-flex">
                                    <MdEmail className={bem.e('nav-item-icon')}/>
                                    <span className="nav-title align-self-start">Quản lý Email</span>
                                </div>
                                <MdKeyboardArrowDown
                                    className={bem.e('nav-item-icon')}
                                    style={{
                                        padding: 0,
                                        transform: this.state.isOpenEmail
                                            ? 'rotate(0deg)'
                                            : 'rotate(-90deg)',
                                        transitionDuration: '0.3s',
                                        transitionProperty: 'transform',
                                    }}
                                />
                            </BSNavLink>
                        </NavItem>
                        <Collapse isOpen={this.state.isOpenEmail} className="collapse-group">
                            {
                                navItem.email.map(({to, name, title, exact, Icon}, index) => (
                                    <NavItem key={index} className={bem.e('nav-item')}>
                                        <BSNavLink
                                            id={name}
                                            className=""
                                            tag={NavLink}
                                            to={to}
                                            activeclassname=""
                                            exact={exact}
                                        >
                                            <Icon className={bem.e('nav-item-icon')}/>
                                            <span className="">{title}</span>
                                        </BSNavLink>
                                    </NavItem>
                                ))
                            }
                        </Collapse>
                        {/* Thông tin */}
                        <NavItem
                            className={bem.e('nav-item')}
                            onClick={this.handleClick('Infomation')}
                        >
                            <BSNavLink className={bem.e('nav-item-collapse')}>
                                <div className="d-flex">
                                    <FaBell className={bem.e('nav-item-icon')}/>
                                    <span className="nav-title align-self-start">Quản lý thông tin</span>
                                </div>
                                <MdKeyboardArrowDown
                                    className={bem.e('nav-item-icon')}
                                    style={{
                                        padding: 0,
                                        transform: this.state.isOpenInfomation
                                            ? 'rotate(0deg)'
                                            : 'rotate(-90deg)',
                                        transitionDuration: '0.3s',
                                        transitionProperty: 'transform',
                                    }}
                                />
                            </BSNavLink>
                        </NavItem>
                        <Collapse isOpen={this.state.isOpenInfomation} className="collapse-group">
                            {
                                navItem.infomation.map(({to, name, title, exact, Icon}, index) => (
                                    <NavItem key={index} className={bem.e('nav-item')}>
                                        <BSNavLink
                                            id={name}
                                            className=""
                                            tag={NavLink}
                                            to={to}
                                            activeclassname=""
                                            exact={exact}
                                        >
                                            <Icon className={bem.e('nav-item-icon')}/>
                                            <span className="">{title}</span>
                                        </BSNavLink>
                                    </NavItem>
                                ))
                            }
                        </Collapse>
                        {/* ./ Thông tin */}
                        {/* {
                        navItem.tutorial.map(({ to, name, title, exact, Icon }, index) => (
                            <NavItem key={index} className={bem.e('nav-item')}>
                                <BSNavLink
                                    id={`navItem-${name}-${index}`}
                                    tag={NavLink}
                                    to={to}
                                    exact={exact}
                                >
                                    <Icon className={bem.e('nav-item-icon')} />
                                    <span className="nav-title">{ title }</span>
                                </BSNavLink>
                                </NavItem>
                            ))
                        } */}

                        {/* Log */}
                        {/* {
                            navItem.log.map(({to, name, exact, Icon}, index) => (
                                <NavItem key={index} className={bem.e('nav-item')}>
                                    <BSNavLink
                                        id={`navItem-${name}-${index}`}
                                        tag={NavLink}
                                        to={to}
                                        exact={exact}
                                    >
                                        <FaHistory className={bem.e('nav-item-icon')}/>
                                        <span className="nav-title">Quản lý hoạt động</span>
                                    </BSNavLink>
                                </NavItem>
                            ))
                        } */}

                        {/* Tiket */}
                        {/* {
                            navItem.ticket.map(({to, name, exact, Icon}, index) => (
                                <NavItem key={index} className={bem.e('nav-item')}>
                                    <BSNavLink
                                        id={`navItem-${name}-${index}`}
                                        tag={NavLink}
                                        to={to}
                                        exact={exact}
                                    >
                                        <FaLifeRing className={bem.e('nav-item-icon')}/>
                                        <span className="nav-title">Ticket</span>
                                    </BSNavLink>
                                </NavItem>
                            ))
                        } */}

                        {/* Alert Admin */}
                        {/* {
                            navItem.alert_admin.map(({to, name, title, exact, Icon}, index) => (
                                <NavItem key={index} className={bem.e('nav-item')}>
                                    <BSNavLink
                                        id={`navItem-${name}-${index}`}
                                        tag={NavLink}
                                        to={to}
                                        exact={exact}
                                    >
                                        <Icon className={bem.e('nav-item-icon')}/>
                                        <span className="nav-title">{title}</span>
                                    </BSNavLink>
                                </NavItem>
                            ))
                        } */}

                        {/* Auto Banking */}
                        {/* {
                            this.props.autoBanking ? (
                                <>
                                    {
                                        navItem.auto_banking.map(({to, name, exact, Icon}, index) => (
                                            <NavItem key={index} className={bem.e('nav-item')}>
                                                <BSNavLink
                                                    id={`navItem-${name}-${index}`}
                                                    tag={NavLink}
                                                    to={to}
                                                    exact={exact}
                                                >
                                                    <RiBankFill className={bem.e('nav-item-icon')}/>
                                                    <span className="nav-title">Auto Banking</span>
                                                </BSNavLink>
                                            </NavItem>
                                        ))
                                    }
                                </>
                            ) : (
                                <></>
                            )
                        } */}

                        {/* Send Mail */}
                        {/* {
                          navItem.send_mail.map(({ to, name, title, exact, Icon }, index) => (
                            <NavItem key={index} className={bem.e('nav-item')}>
                                <BSNavLink
                                    id={`navItem-${name}-${index}`}
                                    tag={NavLink}
                                    to={to}
                                    exact={exact}
                                >
                                    <Icon className={bem.e('nav-item-icon')} />
                                    <span className="nav-title">{ title }</span>
                                </BSNavLink>
                            </NavItem>
                          ))
                        } */}

                        {/* Notifications Admin */}
                        {/*{*/}
                        {/*  navItem.noti_admin.map(({ to, name, title, exact, Icon }, index) => (*/}
                        {/*    <NavItem key={index} className={bem.e('nav-item')}>*/}
                        {/*        <BSNavLink*/}
                        {/*            id={`navItem-${name}-${index}`}*/}
                        {/*            tag={NavLink}*/}
                        {/*            to={to}*/}
                        {/*            exact={exact}*/}
                        {/*        >*/}
                        {/*            <Icon className={bem.e('nav-item-icon')} />*/}
                        {/*            <span className="nav-title">{ title }</span>*/}
                        {/*        </BSNavLink>*/}
                        {/*    </NavItem>*/}
                        {/*  ))*/}
                        {/*}*/}

                        {/* System Config */}
                        {/* {
                            navItem.config_system.map(({to, name, exact, Icon}, index) => (
                                <NavItem key={index} className={bem.e('nav-item')}>
                                    <BSNavLink
                                        id={`navItem-${name}-${index}`}
                                        tag={NavLink}
                                        to={to}
                                        exact={exact}
                                    >
                                        <AiFillSetting className={bem.e('nav-item-icon')}/>
                                        <span className="nav-title">Cài đặt hệ thống</span>
                                    </BSNavLink>
                                </NavItem>
                            ))
                        } */}

                        {/* Hệ thống */}
                        <NavItem
                            className={bem.e('nav-item')}
                            onClick={this.handleClick('System')}
                        >
                            <BSNavLink className={bem.e('nav-item-collapse')}>
                                <div className="d-flex">
                                    <AiFillSetting className={bem.e('nav-item-icon')}/>
                                    <span className="nav-title align-self-start">Cài đặt</span>
                                </div>
                                <MdKeyboardArrowDown
                                    className={bem.e('nav-item-icon')}
                                    style={{
                                        padding: 0,
                                        transform: this.state.isOpenSystem
                                            ? 'rotate(0deg)'
                                            : 'rotate(-90deg)',
                                        transitionDuration: '0.3s',
                                        transitionProperty: 'transform',
                                    }}
                                />
                            </BSNavLink>
                        </NavItem>
                        <Collapse isOpen={this.state.isOpenSystem} className="collapse-group">
                            {
                                navItem.config_system.map(({to, name, title, exact, Icon}, index) => (
                                    <NavItem key={index} className={bem.e('nav-item')}>
                                        <BSNavLink
                                            id={name}
                                            className=""
                                            tag={NavLink}
                                            to={to}
                                            activeclassname=""
                                            exact={exact}
                                        >
                                            <Icon className={bem.e('nav-item-icon')}/>
                                            <span className="">{title}</span>
                                        </BSNavLink>
                                    </NavItem>
                                ))
                            }
                        </Collapse>
                        {/* ./ Hệ thống */}

                    </Nav>
                </div>
            </aside>
        );
    }
}

const mapStateToProps = (state) => {
    // console.log(state.system);
    return {
        user: state.user.user,
        sessionRole: state.user.sessionRole,
        vps: state.system.vps,
        proxy: state.system.proxy,
        vps_us: state.system.vps_us,
        cloudServer: state.system.cloudServer,
        hosting: state.system.hosting,
        menuProduct: state.system.menuProduct,
        config: state.configSystem.config,
        autoBanking: state.configSystem.autoBanking,
    }
}
export default connect(mapStateToProps)(Sidebar);